import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TicketStatusDto } from '../../../data/models/ticket-status-dto';
import { AccountLineSubjectService } from '../../../services/account-line-subject.service';
import { CcPortalService } from '../../../services/cc-portal.service';
import { TicketsService } from '../../../services/tickets.service';
import { CommonGlobalService } from '../../../services/common-global.service';

@Component({
  selector: 'app-cc-ticket',
  templateUrl: './cc-ticket.component.html',
  styleUrls: ['./cc-ticket.component.scss'],
  providers:[MessageService]
})
export class CcTicketComponent implements OnInit {
  @Input() lineQuote: string;
  @Input() lineId: number;

  ticketsOfLine: TicketStatusDto[] = [];
  constructor(private ticketService: TicketsService, private messageService: MessageService,
    private accountLineChangesService: AccountLineSubjectService,private commonGlobalService: CommonGlobalService) { }

  ngOnInit() {
    //if (this.lineQuote) 
    //  this.getTickets(this.lineQuote);

  }
  ngOnChanges() {
    if (this.lineQuote)
      this.getTickets(this.lineQuote);
  }
  getTickets(lineQuote: string) {

    this.ticketService.getTicketByQuoteId(lineQuote).subscribe((res: TicketStatusDto[]) => {
      if (res) {
        console.log("line tickets =",res);
        this.ticketsOfLine = res;
       
      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Get Ticket By Quote', detail: 'unable to get tickets of that line' });

    })
  }

  getSeverity(line: any) {

    let lineIndex = this.ticketsOfLine.findIndex(e => e.srNumber == line.srNumber);


    let status = this.commonGlobalService.getStringAtIndex(line.status, lineIndex);
    switch (status) {
      case 'Opened':
        return 'text-success';
      case 'Closed':
        return 'text-danger';
      case 'in-Progress':
        return 'text-warning';
    }
  }

  
 
}
